import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M21 19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21L5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19L3 5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3L19 3C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5L21 19ZM16 19L19 19L19 5L16 5L16 19ZM14 19L14 5L5 5L5 19L14 19ZM7 9.8225L9.47234 12.5L7 15.1775L7.76113 16L11 12.5L7.76113 9L7 9.8225Z" />,
  'PanelOpen',
)
